<template>
	<div>
    <b-sidebar id="sidebar-right-stock" :title="currentSymbolName" :width="sidebarWidth" backdrop :right="placement==='right'" shadow @shown="onSidebarShown" @hidden="onSidebarHidden" z-index="2000">
            <template #title>
                <div class="d-flex align-items-center flex-wrap sidebar-header-container w-100">
                    <div class="mr-2 font-weight-bold" style="font-size: 16px;">{{ currentSymbolName }}</div>
                    <span class="text-muted small mr-2">{{ currentSymbolCode }}</span>
                    
                    <!-- 快捷切换上一只 / 下一只股票 -->
                    <div class="stock-switch-nav d-inline-flex align-items-center mr-auto" v-if="hasStockList">
                        <b-button-group size="sm" class="my-1">
                            <b-button 
                                size="sm" 
                                variant="outline-primary" 
                                class="px-2 py-0 stock-nav-btn" 
                                :disabled="!hasPrevStock" 
                                @click="switchStock(-1)" 
                                title="上一只股票 (快捷键: ↑ 或 PageUp)"
                            >
                                <span class="d-none d-sm-inline">◀ 上一只</span>
                                <span class="d-inline d-sm-none">◀</span>
                            </b-button>
                            <b-button 
                                size="sm" 
                                variant="outline-secondary" 
                                class="px-2 py-0 stock-index-badge text-muted" 
                                disabled
                                style="font-size: 11px; cursor: default;"
                            >
                                {{ currentIndex >= 0 ? (currentIndex + 1) + '/' + effectiveStockList.length : '--' }}
                            </b-button>
                            <b-button 
                                size="sm" 
                                variant="outline-primary" 
                                class="px-2 py-0 stock-nav-btn" 
                                :disabled="!hasNextStock" 
                                @click="switchStock(1)" 
                                title="下一只股票 (快捷键: ↓ 或 PageDown)"
                            >
                                <span class="d-none d-sm-inline">下一只 ▶</span>
                                <span class="d-inline d-sm-none">▶</span>
                            </b-button>
                        </b-button-group>
                    </div>

                    <div class="d-flex align-items-center ml-auto">
                        <b-button v-if="viewportWidth > 768" size="sm" variant="secondary" class="mr-2" @click="toggleFullscreen">{{ isFullscreen ? '退出全屏' : '全屏' }}</b-button>
                        <b-button size="sm" variant="outline-secondary" @click="togglePlacement">{{ placement==='right' ? '左侧' : '右侧' }}</b-button>
                    </div>
                </div>
            </template>
            <div class="calendar-container p-2 border-bottom">
				<div class="d-flex align-items-center flex-nowrap overflow-auto py-1">
					<label class="mb-0 mr-2 font-weight-bold text-nowrap" style="font-size: 13px;">日期</label>
					<b-form-datepicker
						id="datepicker"
						ref="datepicker"
						v-model="localDateMark"
						:min="minDate"
						:max="maxDate"
						:date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
						locale="zh"
						size="sm"
						today-button
						reset-button
						close-button
						@input="onDateChange"
						class="mr-2 custom-stock-datepicker flex-shrink-0"
						style="width: 165px;"
					></b-form-datepicker>
					<b-button-group size="sm" class="flex-shrink-0">
						<b-button size="sm" variant="primary" class="px-2 py-0 today-btn" @click="setToday">今天</b-button>
						<b-button 
							size="sm" 
							variant="outline-primary" 
							class="px-2 py-0 date-nav-btn" 
							@click="switchDate(-1)"
							:disabled="!canPrevDate"
							title="前一日 (快捷键: ← 或 [)"
						>
							◀ 前一日
						</b-button>
						<b-button 
							size="sm" 
							variant="outline-primary" 
							class="px-2 py-0 date-nav-btn" 
							@click="switchDate(1)"
							:disabled="!canNextDate"
							title="后一日 (快捷键: → 或 ])"
						>
							后一日 ▶
						</b-button>
					</b-button-group>
				</div>
            </div>
			<div>
				<StockUpLimitReason :symbol_code="currentSymbolCode" :date_mark="localDateMark"></StockUpLimitReason>
			</div>
		<div class="border">
			<b-form-checkbox
			id="status_popular"
			v-model.number="status_popular"
			name="status_popular"
			value="1"
			unchecked-value="0">
			人气
			</b-form-checkbox>
		</div>
        
            <div v-if="!is_show_popular" class="m-l-5">
                <StockKlineDay ref="klineDay" :chart_width="chart_width" :chart_heigh="chart_heigh" :chart_rank_line="chart_rank_line" :symbol_code="currentSymbolCode" :highlightDate="localDateMark" :title="currentSymbolCode" :subText="currentSymbolName" @date-selected="onDateSelected" @dates-loaded="onKlineDatesLoaded"></StockKlineDay>
            </div>
            <div v-if="is_show_popular" class="m-l-5">
                <StockKlineWithPopular ref="klinePopular" :chart_width="chart_width" :chart_heigh="chart_heigh" :chart_rank_line="chart_rank_line" :symbol_code="currentSymbolCode" :highlightDate="localDateMark" :title="currentSymbolCode" :subText="currentSymbolName" @date-selected="onDateSelected" @dates-loaded="onKlineDatesLoaded"></StockKlineWithPopular>
            </div>
            <div class="m-l-5">
                <StockTrend :key="currentSymbolCode + ':' + status_popular + ':' + sidebarShownTick" :chart_width="chart_width" :chart_heigh="chart_heigh" :symbol_code="currentSymbolCode" :title="currentSymbolName" :subText="currentSymbolCode" :selected_date="selected_date" :can-prev="canPrevDate" :can-next="canNextDate" @prev-day="switchDate(-1)" @next-day="switchDate(1)"></StockTrend>
            </div>
			<div>
				<StockPlates :symbol_code="currentSymbolCode" :symbol_name="currentSymbolName"></StockPlates>
			</div>
			<div class="clearfix"></div>
			
		</b-sidebar>
	</div>
</template>

<script>
	import StockKlineWithPopular from 'components/stock/StockKlineWithPopular.vue'
	import StockKlineDay from 'components/stock/StockKlineDay.vue'
	import StockTrend from 'components/stock/StockTrend.vue'
	import StockPlates from 'components/stock/StockPlates.vue'
	import StockUpLimitReason from 'components/stock/StockUpLimitReason.vue'
	import { tdxLinkStock } from '@/utils/tdx_link.js'

	export default {
		props: {
			symbol_code: String,
			symbol_name: String,
			date_mark: String,
			stock_list: {
				type: Array,
				default: () => []
			}
		},
		computed: {
			is_show_popular() {
				return new Number(this.status_popular) == 1;
			},
			sidebarWidth() {
				return this.isFullscreen ? '100vw' : ((this.viewportWidth <= 768) ? '100vw' : '40vw');
			},
			effectiveStockList() {
				if (Array.isArray(this.stock_list) && this.stock_list.length > 0) {
					return this.stock_list;
				}
				return this.internalStockList || [];
			},
			hasStockList() {
				return this.effectiveStockList && this.effectiveStockList.length > 1;
			},
			currentIndex() {
				const list = this.effectiveStockList;
				if (!list || list.length === 0) return -1;
				const code = this.currentSymbolCode;
				const name = this.currentSymbolName;
				return list.findIndex(item => {
					const c = item.stock_code || item.symbol_code || item.code;
					const n = item.stock_name || item.symbol_name || item.name;
					if (code && c && String(code) === String(c)) return true;
					if (name && n && String(name) === String(n)) return true;
					return false;
				});
			},
			hasPrevStock() {
				return this.currentIndex > 0;
			},
			hasNextStock() {
				return this.currentIndex >= 0 && this.currentIndex < this.effectiveStockList.length - 1;
			},
			canPrevDate() {
				if (!this.localDateMark) return true;
				const cur = this.normalizeDate(this.localDateMark);
				if (this.klineDates && this.klineDates.length > 0) {
					return cur > this.klineDates[0];
				}
				return cur > this.minDate;
			},
			canNextDate() {
				if (!this.localDateMark) return false;
				const cur = this.normalizeDate(this.localDateMark);
				if (this.klineDates && this.klineDates.length > 0) {
					return cur < this.klineDates[this.klineDates.length - 1];
				}
				return cur < this.maxDate;
			}
		},
		data() {
			return {
				status_popular: 0,
				colorblind: false,
				chart_rank_line: { width: 1, opacity: 0.3, color: '#E69F00' },
				chart_width: '100%',
				chart_heigh: '350px',
				selected_date: '', // 存储选中的日期
				localDateMark: '', // 本地日期，初始值在watch immediate中设置
				klineDates: [], // 当前股票已加载的所有交易日列表
				minDate: '2010-01-01', // 日历最小日期
				maxDate: new Date().toISOString().split('T')[0], // 日历最大日期为今天
				viewportWidth: 1024,
				isFullscreen: false,
				sidebarShownTick: 0,
				placement: 'left',
				currentSymbolCode: '',
				currentSymbolName: '',
				internalStockList: [],
				isSidebarVisible: false
			};
		},
		mounted() {
			const c = localStorage.getItem('site.colorblind');
			if (c) { this.colorblind = (c === '1' || c === 'true'); }
			const p = localStorage.getItem('site.sidebarPlacement');
			if (p) { this.placement = p; }
			this.chart_rank_line.color = this.colorblind ? '#E69F00' : '#ec0000';
			this.viewportWidth = window.innerWidth || 1024;
			this._onResize = () => { this.viewportWidth = window.innerWidth || this.viewportWidth; };
			window.addEventListener('resize', this._onResize);

			this.$root.$on('stock-sidebar-set-data', this.onSetData);
			this.$root.$on('stock-sidebar-set-list', this.onSetList);
		},
		beforeDestroy() {
			if (this._onResize) { window.removeEventListener('resize', this._onResize); }
			window.removeEventListener('keydown', this.handleKeyDown);
			this.$root.$off('stock-sidebar-set-data', this.onSetData);
			this.$root.$off('stock-sidebar-set-list', this.onSetList);
		},
		watch: {
			symbol_code: {
				handler(newVal) {
					if (newVal !== this.currentSymbolCode) {
						this.currentSymbolCode = newVal;
					}
					if (newVal) {
						const isTdxHandled = tdxLinkStock(newVal);
						if (isTdxHandled) {
							this.$nextTick(() => {
								this.$root.$emit('bv::hide::sidebar', 'sidebar-right-stock');
							});
						}
					}
				},
				immediate: true
			},
			symbol_name: {
				handler(newVal) {
					if (newVal !== this.currentSymbolName) {
						this.currentSymbolName = newVal;
					}
				},
				immediate: true
			},
			stock_list: {
				handler(newVal) {
					if (Array.isArray(newVal) && newVal.length > 0) {
						this.internalStockList = newVal;
					}
				},
				immediate: true
			},
			date_mark: {
				handler(newVal) {
					this.localDateMark = this.normalizeDate(newVal);
					this.selected_date = this.localDateMark;
				},
				immediate: true
			}
		},
		methods: {
			normalizeDate(date) {
				if (!date) return '';
				if (typeof date !== 'string') date = String(date);
				date = date.trim();
				if (date.indexOf(' ') > -1) { date = date.split(' ')[0]; }
				
				let formattedDate = date;
				if (/^\d{8}$/.test(date)) {
					formattedDate = date.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
				} else if (/^\d{4}[/-]\d{1,2}[/-]\d{1,2}$/.test(date)) {
					const parts = date.replace(/\//g, '-').split('-');
					const y = parts[0];
					const m = parts[1].padStart(2, '0');
					const d = parts[2].padStart(2, '0');
					formattedDate = `${y}-${m}-${d}`;
				}
				return formattedDate;
			},
			onDateSelected(date) {
				this.selected_date = date;
				const formattedDate = date.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
				this.localDateMark = formattedDate;
			},
			onDateChange(date) {
				this.selected_date = date;
				this.localDateMark = date;
				this.$emit('date-mark-change', date);
			},
			setToday() {
				if (this.klineDates && this.klineDates.length > 0) {
					const latest = this.klineDates[this.klineDates.length - 1];
					this.onDateChange(latest);
				} else {
					const today = this.maxDate;
					this.onDateChange(today);
				}
			},
			onKlineDatesLoaded(dates) {
				if (Array.isArray(dates) && dates.length > 0) {
					this.klineDates = dates;
					if (!this.localDateMark) {
						this.localDateMark = dates[dates.length - 1];
						this.selected_date = this.localDateMark;
					}
				}
			},
			switchDate(direction) {
				if (!this.localDateMark) {
					if (this.klineDates && this.klineDates.length > 0) {
						this.localDateMark = this.klineDates[this.klineDates.length - 1];
					} else {
						this.localDateMark = this.maxDate;
					}
				}
				const curDate = this.normalizeDate(this.localDateMark);
				if (this.klineDates && this.klineDates.length > 0) {
					const idx = this.klineDates.indexOf(curDate);
					if (idx !== -1) {
						const nextIdx = idx + direction;
						if (nextIdx >= 0 && nextIdx < this.klineDates.length) {
							this.onDateChange(this.klineDates[nextIdx]);
							return;
						}
					} else {
						if (direction < 0) {
							for (let i = this.klineDates.length - 1; i >= 0; i--) {
								if (this.klineDates[i] < curDate) {
									this.onDateChange(this.klineDates[i]);
									return;
								}
							}
						} else {
							for (let i = 0; i < this.klineDates.length; i++) {
								if (this.klineDates[i] > curDate) {
									this.onDateChange(this.klineDates[i]);
									return;
								}
							}
						}
					}
				}

				// 容灾后备：若未加载K线日期，按日历跳过周末
				const d = new Date(curDate);
				if (isNaN(d.getTime())) return;
				d.setDate(d.getDate() + direction);
				if (d.getDay() === 0) {
					d.setDate(d.getDate() + (direction < 0 ? -2 : 1));
				} else if (d.getDay() === 6) {
					d.setDate(d.getDate() + (direction < 0 ? -1 : 2));
				}
				const y = d.getFullYear();
				const m = String(d.getMonth() + 1).padStart(2, '0');
				const day = String(d.getDate()).padStart(2, '0');
				const res = `${y}-${m}-${day}`;
				if (res <= this.maxDate) {
					this.onDateChange(res);
				}
			},
			toggleFullscreen() {
				this.isFullscreen = !this.isFullscreen;
			},
			onSidebarShown() {
				this.sidebarShownTick++;
				this.isSidebarVisible = true;
				window.addEventListener('keydown', this.handleKeyDown);
			},
			onSidebarHidden() {
				this.isSidebarVisible = false;
				window.removeEventListener('keydown', this.handleKeyDown);
			},
			togglePlacement() {
				this.placement = this.placement === 'left' ? 'right' : 'left';
				localStorage.setItem('site.sidebarPlacement', this.placement);
			},
			onSetData(data) {
				if (!data) return;
				if (data.stock_list && Array.isArray(data.stock_list) && data.stock_list.length > 0) {
					this.internalStockList = data.stock_list;
				}
				if (data.stock_code) {
					this.currentSymbolCode = data.stock_code;
				}
				if (data.stock_name) {
					this.currentSymbolName = data.stock_name;
				}
				if (data.date1 || data.date_mark) {
					this.localDateMark = this.normalizeDate(data.date1 || data.date_mark);
					this.selected_date = this.localDateMark;
				}
			},
			onSetList(list) {
				if (Array.isArray(list) && list.length > 0) {
					this.internalStockList = list;
				}
			},
			handleKeyDown(e) {
				if (!this.isSidebarVisible) return;
				const tag = e.target && e.target.tagName;
				if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return;
				if (e.target && e.target.isContentEditable) return;

				if (e.key === 'ArrowDown' || e.key === 'PageDown') {
					if (this.hasStockList) {
						e.preventDefault();
						if (this.hasNextStock) {
							this.switchStock(1);
						}
					}
				} else if (e.key === 'ArrowUp' || e.key === 'PageUp') {
					if (this.hasStockList) {
						e.preventDefault();
						if (this.hasPrevStock) {
							this.switchStock(-1);
						}
					}
				} else if (e.key === 'ArrowLeft' || e.key === '[') {
					e.preventDefault();
					if (this.canPrevDate) {
						this.switchDate(-1);
					}
				} else if (e.key === 'ArrowRight' || e.key === ']') {
					e.preventDefault();
					if (this.canNextDate) {
						this.switchDate(1);
					}
				}
			},
			switchStock(offset) {
				const list = this.effectiveStockList;
				const targetIdx = this.currentIndex + offset;
				if (targetIdx < 0 || targetIdx >= list.length) return;
				const targetItem = list[targetIdx];
				if (!targetItem) return;

				const nextCode = targetItem.stock_code || targetItem.symbol_code || targetItem.code;
				const nextName = targetItem.stock_name || targetItem.symbol_name || targetItem.name;
				const nextDate = targetItem.date1 || targetItem.date_mark || this.localDateMark;

				this.currentSymbolCode = nextCode;
				this.currentSymbolName = nextName;
				if (nextDate) {
					this.localDateMark = this.normalizeDate(nextDate);
					this.selected_date = this.localDateMark;
				}

				if (nextCode) {
					const isTdxHandled = tdxLinkStock(nextCode);
					if (isTdxHandled) {
						this.$nextTick(() => {
							this.$root.$emit('bv::hide::sidebar', 'sidebar-right-stock');
						});
					}
				}

				const payload = {
					stock_code: nextCode,
					stock_name: nextName,
					date1: nextDate,
					date_mark: nextDate,
					index: targetIdx,
					total: list.length
				};
				this.$emit('change-stock', payload);
				this.$emit('update:symbol_code', nextCode);
				this.$emit('update:symbol_name', nextName);
				this.$emit('date-mark-change', nextDate);
				this.$root.$emit('stock-sidebar-stock-changed', payload);
			}
		},
		components: {
			StockKlineWithPopular,
			StockKlineDay,
			StockTrend,
			StockPlates,
			StockUpLimitReason
		}
	}
</script>

<style scoped>
.stock-switch-nav {
	user-select: none;
}
.stock-nav-btn {
	font-size: 12px;
	line-height: 1.6;
	border-color: var(--primary, #007bff);
}
.date-nav-btn {
	font-size: 12px;
	line-height: 1.5;
	padding: 2px 8px !important;
	border-color: var(--primary, #007bff);
	white-space: nowrap;
}
.today-btn {
	font-size: 12px;
	line-height: 1.5;
	padding: 2px 10px !important;
	white-space: nowrap;
}
.custom-stock-datepicker >>> label,
.custom-stock-datepicker >>> output,
.custom-stock-datepicker >>> .btn,
.custom-stock-datepicker >>> .form-control {
	white-space: nowrap !important;
	overflow: hidden !important;
	text-overflow: ellipsis !important;
	line-height: 1.5 !important;
	font-size: 12px !important;
}
.stock-index-badge {
	background: var(--bg-muted, rgba(0, 0, 0, 0.05)) !important;
	border-color: var(--border-color, #ced4da) !important;
	color: var(--text-muted, #6c757d) !important;
	font-weight: 600;
}
body.theme-dark .stock-index-badge {
	background: rgba(255, 255, 255, 0.1) !important;
	border-color: #495057 !important;
	color: #adb5bd !important;
}
</style>